export const STRATEGY_BENCHMARK_CHART_COLORS = Object.freeze({
  strategy: {
    line: "rgb(40, 149, 240)",
    top: "rgba(40, 149, 240, 0.35)",
    bottom: "rgba(255, 255, 255, 0)"
  },
  wig20: "#e53935",
  mwig40: "#d9a000",
  swig80: "#B639F9"
});
